import React from 'react';
export default function BillingSuccess() {
    return <div>Subscription successful.</div>
}